module.exports = __webpack_public_path__ + "img/5.06.dac034a7.jpg";